import { useSignoutUser } from "@/hooks/useSignoutUser";

export const SignoutUser = () => {
  useSignoutUser();

  return (
    <div className="d-flex flex-column min-vh-100 min-vw-100">
      <div className="d-flex flex-grow-1 justify-content-center align-items-center">
        <div className="text-center">
          <div className="py-4">
            <img src="/img/dragonflyai-ident.svg" height={48} alt="Dragonfly AI Logo" />
            <p className="lead">Please wait ...</p>
          </div>
        </div>
      </div>
    </div>
  );
};
